import { iconsIdByName, slotBarSymbolNames } from '../pixi/resources';

export const payTableListWeb = [
  {
    id: iconsIdByName[slotBarSymbolNames.star],
    countX: 561,
    countY: -121,
    oddX: 599.5,
    oddY: -121,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.dollar],
    countX: 898,
    countY: -104,
    oddX: 944,
    oddY: -104,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.seven],
    x: 0,
    y: 0,
    countX: 227,
    oddX: 272,
    countY: 108,
    oddY: 108,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.grape],
    x: 0,
    y: 0,
    countX: 446,
    oddX: 498,
    countY: 117,
    oddY: 117,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.watermelon],
    x: 0,
    y: 0,
    countX: 667,
    oddX: 709,
    countY: 117,
    oddY: 117,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.bell],
    x: 0,
    y: 0,
    countX: 885,
    oddX: 929,
    countY: 117,
    oddY: 117,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.cherry],
    x: 0,
    y: 0,
    countY: 242,
    oddY: 242,
    countX: 227,
    oddX: 272,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.plum],
    x: 0,
    y: 0,
    countY: 242,
    oddY: 242,
    countX: 446,
    oddX: 498,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.orange],
    x: 0,
    y: 0,
    countY: 242,
    oddY: 242,
    countX: 667,
    oddX: 709,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.lemon],
    x: 0,
    y: 0,
    countY: 242,
    oddY: 242,
    countX: 888,
    oddX: 932,
  },
];

export const payTableListMobile = [
  {
    id: iconsIdByName[slotBarSymbolNames.star],
    countX: 280,
    countY: 319,
    oddX: 310,
    oddY: 319,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.dollar],
    countX: 450,
    countY: 335,
    oddX: 480,
    oddY: 335,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.seven],
    x: 0,
    y: 0,
    countX: 100,
    oddX: 130,
    countY: 488,
    oddY: 488,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.grape],
    x: 0,
    y: 0,
    countX: 262,
    oddX: 292,
    countY: 493,
    oddY: 493,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.watermelon],
    x: 0,
    y: 0,
    count: [1, 2, 3],
    countX: 440,
    oddX: 470,
    countY: 493,
    oddY: 493,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.bell],
    x: 0,
    y: 0,
    countX: 100,
    oddX: 130,
    countY: 573,
    oddY: 573,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.cherry],
    x: 0,
    y: 0,
    countY: 573,
    oddY: 573,
    countX: 262,
    oddX: 292,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.plum],
    x: 0,
    y: 0,
    countY: 573,
    oddY: 573,
    countX: 440,
    oddX: 470,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.orange],
    x: 0,
    y: 0,
    countY: 653,
    oddY: 653,
    countX: 179,
    oddX: 209,
  },
  {
    id: iconsIdByName[slotBarSymbolNames.lemon],
    x: 0,
    y: 0,
    countY: 653,
    oddY: 653,
    countX: 352,
    oddX: 382,
  },
];
